<section class="project-info">
  <div class="container">
    <div class="project-content">
      <!-- Columna izquierda: Imágenes -->
      <div class="project-images">
        <div class="image-container">
          <img [src]="getImageUrl('images/resort/arequipa_pool.webp')" alt="Vista aérea del resort" class="background-image">
          <img [src]="getImageUrl('images/resort/arequipa_h.webp')" alt="Vista del resort a nivel del suelo" class="overlay-image">
        </div>
      </div>
      
      <!-- Columna derecha: Texto y botón -->
      <div class="project-text">
        <h2>Proyecto en Arequipa</h2>
        <p class="project-description">
          La Joya Park Resort, con 15 hectáreas, será un destino único para una experiencia de hospedaje excepcional y contará con un parque acuático con toboganes, piscinas, circuitos de agua y playa artificiales, ofreciendo diversión para todas las edades.
        </p>
        <p class="project-description">
          Con esta nueva propuesta en la ciudad de Arequipa, se posicionará como el centro de atracción más grande de Latinoamérica, ¿Qué esperas se parte de nuestros afiliados?
        </p>
        <button class="btn btn-primary gallery-btn" (click)="onToggleGallery()">
          {{ isGalleryOpen ? 'Ocultar galería' : 'Ver galería de fotos' }}
        </button>
      </div>
    </div>
  </div>
</section>
